module.exports = __webpack_public_path__ + "img/person-3.a18fbb1.webp";